module.exports = __webpack_public_path__ + "img/two2.71c903c6.png";